import QuestionChoiceForm from '@App/components/QuestionChoiceForm/QuestionChoiceForm';

function Question4Form() {
  return <QuestionChoiceForm questionId="question4" titleKey="hexagon-layer-title" inputPlaceholderKey="hexagon-layer-input-placeholder" resultsTitleKey="hexagon-layer-results-title" nextRoute="../question5" />;
}

export default Question4Form;
